import { useQuery } from '@tanstack/react-query'
import type { DashboardData } from '@shared/types/progress'
import { api } from './api'

export const progressKeys = {
  dashboard: ['progress', 'dashboard'] as const,
}

export function useDashboard() {
  return useQuery({
    queryKey: progressKeys.dashboard,
    queryFn: () =>
      api<{ dashboard: DashboardData; displayName: string }>('/progress/dashboard'),
    // The countdown and streak are day-scale values; refetching on every focus
    // would just spend her data allowance.
    staleTime: 60_000,
  })
}

export type PartOfDay = 'morning' | 'afternoon' | 'evening'

/**
 * Derived from the device clock rather than the server.
 *
 * The browser already knows the wall-clock time where she is standing, which
 * is exactly what a greeting should follow — and it stays right even if she
 * travels to Brazil without updating her profile timezone.
 */
export function partOfDay(now: Date = new Date()): PartOfDay {
  const hour = now.getHours()
  if (hour < 12) return 'morning'
  if (hour < 18) return 'afternoon'
  return 'evening'
}

const GREETINGS: Record<PartOfDay, { pt: string; en: string }> = {
  morning: { pt: 'Bom dia', en: 'Good morning' },
  afternoon: { pt: 'Boa tarde', en: 'Good afternoon' },
  evening: { pt: 'Boa noite', en: 'Good evening' },
}

/** Greets her in Portuguese — the greeting is Unit 1, lesson 2. */
export function greeting(now?: Date): { pt: string; en: string } {
  return GREETINGS[partOfDay(now)]
}
